import { render, staticRenderFns } from "./DetailUserComponent.vue?vue&type=template&id=335e0c89&scoped=true&"
import script from "./DetailUserComponent.vue?vue&type=script&lang=js&"
export * from "./DetailUserComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetailUserComponent.vue?vue&type=style&index=0&id=335e0c89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335e0c89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDataTable,VDivider,VIcon,VSpacer,VSwitch,VToolbar,VToolbarTitle})
